import * as Yup from 'yup';
import {
  CreateClaimField,
  getClaimFieldRequiredErrorMessage,
  getClaimFieldWrongTypeErrorMessage,
} from '@converge/data';
import { customDateStartOfDay } from '../../../../domain/underwriting/create-submission/create.submission.validation.schema';

export const stringRequired = (fieldName: CreateClaimField) => {
  return Yup.string()
    .typeError(getClaimFieldWrongTypeErrorMessage(fieldName))
    .required(getClaimFieldRequiredErrorMessage())
    .trim()
    .min(1, getClaimFieldRequiredErrorMessage());
};

export const createClaimFieldsSchema = Yup.object({
  [CreateClaimField.PolicyUuid]: stringRequired(CreateClaimField.PolicyUuid),
  [CreateClaimField.Description]: Yup.string().optional(),
  [CreateClaimField.DiscoveryDate]: customDateStartOfDay(),
  [CreateClaimField.ReportedDate]: customDateStartOfDay(),
});
